<template>
    <a-modal
      title="已完成问题反馈"
      :visible="visible"
      dialogClass="info-message-box"
      :width="800"
      :pagination="pagination"
      @cancel="handleCancel"
      @change="handleTableChange"
    >
        <template slot="footer">
            <a-button key="back" @click="handleCancel">
            确定
            </a-button>
        </template>
        <a-table :columns="columns" :data-source="tableData">
        </a-table>
    </a-modal>
</template>

<script>
import axios from 'axios';
import { getCookie } from "@/utils/common";

export default {
  name: 'infoMessage',
 components: {},
 props: {
    visible: {
        type: Boolean,
        default: false
    }
 },
 data() {
   return {
    columns: [
        {
            title: '问题描述',
            dataIndex: 'description',
            key: 'description',
            width: 200,
            ellipsis: true
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 150,
        },
        {
            title: '解决情况',
            dataIndex: 'feedback',
            key: 'feedback',
            width: 200,
            ellipsis: true
        }
    ],
    tableData: [],
    pagination: {}
  };
 },
 watch: {
  visible(val){
    if (val) {
      this.getTableData();
    }
  }
 },
 computed: {},
 created() {
    // this.getTableData();
 },
 mounted() {},
 methods: {
    handleCancel() {
        this.$emit('closeInfoMessage')
    },
    getTableData() {
        let url = '/faq/problemFeedback/findMyNewFeedback';
      const token = getCookie('loginKey')
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      axios.defaults.headers.token = token;
      axios.get(url).then(res => {
        console.log('getMessage', res)
        if (!res) return;
        let data = res.data;
        if (data.code === 0) {
            this.tableData = data.data;
          // this.infoCount = data.data
        }
      })
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
    }
 },
};
</script>
<style scoped>
</style>